import { memo, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { useLogout, getEncodedLoginUrlWithSearchParams } from "common/authentication";
import { segmentTrack } from "util/segment";
import { SEGMENT_EVENTS } from "constants/analytics";
import { useViewer } from "util/viewer_wrapper";
import StopWatch from "assets/images/stopwatch-platform.svg";
import { Footer, MainHeading, NextStepButton, ResponsiveWrapper } from "common/signer/common";
import { Paragraph } from "common/core/typography";
import Svg from "common/core/svg";

function SessionExpiredModal() {
  const [searchParams] = useSearchParams();
  const loginUrl = getEncodedLoginUrlWithSearchParams({
    redirectUrl: searchParams.get("returnUrl") || "/",
  });
  const login = useLogout({ redirectUrl: loginUrl });
  const viewer = useViewer();

  const reconnectWarning = window.sessionStorage.getItem("reconnect_warning") === "true";
  useEffect(() => {
    segmentTrack(SEGMENT_EVENTS.SESSION_EXPIRED);
    window.sessionStorage.removeItem("reconnect_warning");
    viewer.refetch();
  }, []);
  return (
    <ResponsiveWrapper centered fullHeight proofHalfLightBackground>
      <>
        <Svg src={StopWatch} alt="" aria-hidden="true" />
        <MainHeading>
          {
            <FormattedMessage
              id="826d1578-ca43-42c9-8c64-65095e772805"
              defaultMessage="Your session has expired"
            />
          }
        </MainHeading>
        <Paragraph>
          {reconnectWarning ? (
            <FormattedMessage
              id="f7317df8-4b5a-484a-bc6b-f22c36d26f49"
              defaultMessage="For account security, your session has ended. Click the button below to log in again."
            />
          ) : (
            <FormattedMessage
              id="720fae8e-3a17-47cd-bf06-de0b3fab566b"
              defaultMessage="For your security, we've ended your session due to inactivity. You can safely close this tab or log in again to continue."
            />
          )}
        </Paragraph>
        <Footer
          nextStepButton={
            <NextStepButton
              automationId="session-expired-login"
              onClick={login}
              text={
                <FormattedMessage
                  id="0974467c-d047-49e1-9cd7-a1c142047975"
                  defaultMessage="Log in"
                />
              }
            />
          }
        />
      </>
    </ResponsiveWrapper>
  );
}

export default memo(SessionExpiredModal);
